import { useState, useEffect } from 'react'
import { getOurSkills, getSkills } from '@services/SkillsService'
import { Skill } from '@Interfaces/Data/SkillInterface'
import { User } from '@Interfaces/Data/UserInterface'
import { UseSkillsDataReturn } from '@Interfaces/Hooks/DataInterface'

export const useSkillsData = (currentUser: User | null): UseSkillsDataReturn => {
  const [allSkills, setAllSkills] = useState<Skill[]>([])
  const [ourSkills, setOurSkills] = useState<Skill[]>([])

  useEffect(() => {
    getSkills().then((response) => {
      if (response.success && response.data) {
        setAllSkills(response.data)
      }
    })
  }, [])

  useEffect(() => {
    if (currentUser && allSkills.length > 0) {
      const filtered = getOurSkills(currentUser, allSkills)
      setOurSkills(filtered)
    }
  }, [currentUser, allSkills])

  return {
    allSkills,
    setAllSkills,
    ourSkills,
    setOurSkills,
  }
}
